import React from 'react';
import { Space, Typography } from '@svg/antd';
import { useIntl } from '@umijs/max';
import { TextOverflowTooltip } from '@svg/antd-cloud-design'

const { Text } = Typography;

export interface TopicEntry {
  key: React.Key;
  title: string;
  subtitle?: string;
  image?: string;
  type?: string;
}

interface EmptyStateProps {
  onSelect?: (searchValue: string, select: any, type: string) => void;
  searchHistory?: string[];
  hotSearch?: string[];
  topicEntries?: TopicEntry[];
  onClearHistory?: () => void;
  size?: 'large' | 'normal'
}

const EmptyState: React.FC<EmptyStateProps> = ({
  onSelect,
  searchHistory = [],
  hotSearch = [],
  topicEntries = [],
  onClearHistory,
  size
}) => {
  const { formatMessage } = useIntl();

  const handleSelect = (value: string, type: string = 'history') => {
    if (onSelect) {
      onSelect(value, value, type);
    }
  };

  const handleClearHistory = () => {
    if (onClearHistory) {
      onClearHistory();
    }
  };

  const handleTopicSelect = (entry: TopicEntry) => {
    if (onSelect) {
      onSelect('', entry, entry.type || 'topicEntry');
    }
  };

  const isNonZhCNLanguage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    return lang && lang !== 'zh-CN';
  };

  return (
    <div className="dropdown-container">
      {/* 搜索历史 */}
      {searchHistory.length > 0 && (
        <>
          <div className="search-history-section">
            <div className="section-title">
              <Space size={4}>
                <Text>{formatMessage({ id: '最近搜索' })}</Text>
              </Space>
              <i className="material-iconfont icon-delete1" onClick={handleClearHistory}></i>
            </div>
            <Space wrap size={size === 'normal' ? [12, 12] : [12, 12]}>
              {searchHistory.map((item) => (
                <TextOverflowTooltip key={item}>
                  <div
                    className="hot-tag"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      handleSelect(item, 'searchHistory');
                    }}
                  >
                    {item}
                  </div>
                </TextOverflowTooltip>
              ))}
            </Space>
          </div>
        </>
      )}

      {/* 热搜 */}
      {hotSearch.length > 0 && (
        <div className="hot-search-section">
          <div className="section-title">
            {/* <Space size={4}>
              <Text>{formatMessage({ id: '热搜' })}</Text>
            </Space> */}
            {isNonZhCNLanguage() ? (
              <span>
                {formatMessage({ id: '热搜' })}
              </span>
            ) : <img src="https://3vj-fe.oss-cn-shenzhen.aliyuncs.com/project/material/img/Union.svg" alt="" />}
            <img src="https://3vj-fe.oss-cn-shenzhen.aliyuncs.com/project/material/img/fire.svg" alt="" />
          </div>
          <Space wrap size={size === 'normal' ? [12, 12] : [12, 12]}>
            {hotSearch.map((item) => (
              <TextOverflowTooltip key={item}>
                <div
                  className="hot-tag"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleSelect(item, 'hotSearch');
                  }}
                >
                  {item}
                </div>
              </TextOverflowTooltip>
            ))}
          </Space>
        </div>
      )
      }
      {topicEntries.length > 0 && (
        <div className="topic-entry-section">
          <div className="section-title">
            <Text>{formatMessage({ id: '素材专题' })}</Text>
          </div>
          <div className="topic-entry-list">
            {topicEntries.map((entry) => (
              <div
                key={entry.key}
                className={`topic-entry-card${entry.type === 'modelTheme' ? ' topic-entry-card-model-theme' : ''}`}
                role="button"
                tabIndex={0}
                onMouseDown={(e) => {
                  e.preventDefault();
                  handleTopicSelect(entry);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleTopicSelect(entry);
                  }
                }}
              >
                <div className="topic-entry-cover">
                  {entry.image ? (
                    <img className="topic-entry-image" src={entry.image} alt={entry.title} />
                  ) : (
                    <div className="topic-entry-icon-wrapper">
                      <i className="material-iconfont icon-a-3D topic-entry-icon"></i>
                    </div>
                  )}
                </div>
                <div className="topic-entry-content">
                  <div className="topic-entry-title">{entry.title}</div>
                  {entry.subtitle ? <div className="topic-entry-subtitle">{entry.subtitle}</div> : null}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div >
  );
};

export default EmptyState;
